import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';
import { MoveDirection } from '@getaccept/lib-shared-new/src/enums/move-direction';
import type { Milestone, Progress, Task } from '../types/action-plan';
export default class ActionPlanConstants {
  static defaultTask: Task = {
    participantIds: [],
    title: '',
    description: '',
    deadline: null,
  };

  static defaultMilestone: Milestone = {
    title: '',
    description: '',
    tasks: [],
  };

  static defaultProgress: Progress = {
    taskCount: 0,
    completedTaskCount: 0,
    completedMilestoneCount: 0,
    milestoneCount: 0,
  };

  static taskOptions = () => [
    {
      title: t('map_edit_task_dropdown'),
      icon: 'edit',
      callback: 'edit',
      dataExternal: 'task-options-menu-edit-option',
    },
    {
      title: t('map_delete_task_dropdown'),
      icon: 'delete-bin',
      callback: 'delete',
      dataExternal: 'task-options-menu-delete-option',
    },
  ];

  static milestoneMoveOptions = () => [
    {
      icon: 'chevron-up-line',
      title: t('move-to-top'),
      callback: MoveDirection.ToTop,
    },
    {
      icon: 'chevron-up',
      title: t('move-up'),
      callback: MoveDirection.Up,
    },
    {
      icon: 'chevron-down',
      title: t('move-down'),
      callback: MoveDirection.Down,
    },
    {
      icon: 'chevron-down-line',
      title: t('move-to-bottom'),
      callback: MoveDirection.ToBottom,
    },
  ];
}
